import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";

export enum OddTypeEnum {
  PRE_EVENT = "PRE_EVENT",
  LIVE = "LIVE",
  ALL = "ALL",
}

export enum ScopeTypeEnum {
  ORDINARY_TIME = "ORDINARY_TIME",
  FULL_TIME = "FULL_TIME",
}

export enum OddFormatEnum {
  DECIMAL = "DECIMAL",
  MONEYLINE = "MONEYLINE",
  FRACTIONAL = "FRACTIONAL",
}

enum Sportal365MarketEnum {
  ONE_X_TWO = "1x2",
  OVER_UNDER = "OVER_UNDER",
  DOUBLE_CHANCE = "DOUBLE_CHANCE",
  BOTH_TO_SCORE = "BOTH_TO_SCORE",
  CORRECT_SCORE = "CORRECT_SCORE",
  FIRST_HALF_AND_FINAL_RESULT = "FIRST_HALF_AND_FINAL_RESULT",
  FIRST_PLAYER_TO_SCORE = "FIRST_PLAYER_TO_SCORE",
  PLAYER_TO_SCORE_DURING_GAME = "PLAYER_TO_SCORE_DURING_GAME",
  PLAYER_TO_RECEIVE_CARD = "PLAYER_TO_RECEIVE_CARD",
}

export enum MatchOddsMarketEnum {
  FT_1X2 = "FT_1X2",
  DOUBLE_CHANCE = "DOUBLE_CHANCE",
  HT_FT = "HT_FT",
  BOTH_TEAMS_SCORE = "BOTH_TEAMS_SCORE",
  CORRECT_SCORE = "CORRECT_SCORE",
  PLAYER_SCORE_FIRST_GOAL = "PLAYER_SCORE_FIRST_GOAL",
  PLAYER_SCORE = "PLAYER_SCORE",
  PLAYER_RED_CARD = "PLAYER_RED_CARD",
  PLAYER_YELLOW_CARD = "PLAYER_YELLOW_CARD",
  OVER_GOALS_0_5 = "OVER_GOALS_0_5",
  OVER_GOALS_1_5 = "OVER_GOALS_1_5",
  OVER_GOALS_2_5 = "OVER_GOALS_2_5",
  OVER_GOALS_3_5 = "OVER_GOALS_3_5",
  OVER_GOALS_4_5 = "OVER_GOALS_4_5",
  OVER_GOALS_5_5 = "OVER_GOALS_5_5",
}

// Type that defines the mapping structure
type MarketEnumMapping = {
  [key in MatchOddsMarketEnum]?: Sportal365MarketEnum;
};

// The actual mapping object
const marketEnumToSportal365: MarketEnumMapping = {
  [MatchOddsMarketEnum.FT_1X2]: Sportal365MarketEnum.ONE_X_TWO,
  [MatchOddsMarketEnum.DOUBLE_CHANCE]: Sportal365MarketEnum.DOUBLE_CHANCE,
  [MatchOddsMarketEnum.HT_FT]: Sportal365MarketEnum.FIRST_HALF_AND_FINAL_RESULT,
  [MatchOddsMarketEnum.BOTH_TEAMS_SCORE]: Sportal365MarketEnum.BOTH_TO_SCORE,
  [MatchOddsMarketEnum.CORRECT_SCORE]: Sportal365MarketEnum.CORRECT_SCORE,
  [MatchOddsMarketEnum.PLAYER_SCORE_FIRST_GOAL]:
    Sportal365MarketEnum.FIRST_PLAYER_TO_SCORE,
  [MatchOddsMarketEnum.PLAYER_SCORE]:
    Sportal365MarketEnum.PLAYER_TO_SCORE_DURING_GAME,
  [MatchOddsMarketEnum.PLAYER_RED_CARD]:
    Sportal365MarketEnum.PLAYER_TO_RECEIVE_CARD,
  [MatchOddsMarketEnum.PLAYER_YELLOW_CARD]:
    Sportal365MarketEnum.PLAYER_TO_RECEIVE_CARD,
};

export default class MatchOddsFilters implements FiltersInterface {
  oddType?: OddTypeEnum = OddTypeEnum.PRE_EVENT;
  scopeType?: ScopeTypeEnum = ScopeTypeEnum.ORDINARY_TIME;
  oddFormat?: OddFormatEnum = OddFormatEnum.DECIMAL;
  marketTypes?: MatchOddsMarketEnum[] = [MatchOddsMarketEnum.FT_1X2];

  constructor(filters: any) {
    this.validateFilters(filters);
  }

  /** @internal */
  constructFiltersUrl?() {
    const marketTypes = this.marketTypes.map((m) =>
      this.mapToSportal365Market(m)
    );

    return `&odd_type=${this.oddType}&scope_type=${this.scopeType}&odd_format=${
      this.oddFormat
    }&market_types=${marketTypes.join(",")}`;
  }

  private validateFilters?(filters: any) {
    const validOddTypes = Object.values(OddTypeEnum);
    const validScopeTypes = Object.values(ScopeTypeEnum);
    const validOddFormats = Object.values(OddFormatEnum);
    const validMarketTypes = Object.values(MatchOddsMarketEnum);

    if (filters?.oddType) {
      if (validOddTypes.includes(filters.oddType)) {
        this.oddType = filters.oddType;
      } else {
        console.warn(
          `The filter "oddType" is NOT valid and therefore it will be set to PRE_EVENT. The VALID values are : ${validOddTypes.join(
            ", "
          )}`
        );
      }
    }

    if (filters?.scopeType) {
      if (validScopeTypes.includes(filters.scopeType)) {
        this.scopeType = filters.scopeType;
      } else {
        console.warn(
          `The filter "scopeType" is NOT valid and therefore it will be set to ORDINARY_TIME. The VALID values are : ${validScopeTypes.join(
            ", "
          )}`
        );
      }
    }

    if (filters?.oddFormat) {
      if (validOddFormats.includes(filters.oddFormat)) {
        this.oddFormat = filters.oddFormat;
      } else {
        console.warn(
          `The filter "oddFormat" is NOT valid and therefore it will be set to DECIMAL. The VALID values are : ${validOddFormats.join(
            ", "
          )}`
        );
      }
    }

    if (
      filters?.marketTypes &&
      Array.isArray(filters?.marketTypes) &&
      filters?.marketTypes.length > 0
    ) {
      if (filters.marketTypes.every((m) => validMarketTypes.includes(m))) {
        this.marketTypes = filters.marketTypes;
      } else {
        console.warn(
          `The filter "marketTypes" is NOT valid and therefore it will be set to FT_1X2. The VALID values are : ${validMarketTypes.join(
            ", "
          )}`
        );
      }
    }
  }

  private mapToSportal365Market?(
    market: MatchOddsMarketEnum
  ): Sportal365MarketEnum {
    if (market.startsWith("OVER_GOALS_")) {
      return Sportal365MarketEnum.OVER_UNDER;
    }

    return marketEnumToSportal365[market];
  }
}
